import {observable, action} from 'mobx';

class Store {
  @observable inputValue = '';

  @observable isValidate = false;

  @action.bound
  setInputVal(val) {
    this.inputValue = val;
  }

  @action.bound
  setValidate(boolean) {
    this.isValidate = boolean;
  }
}

export default Store;
